module.exports = __webpack_public_path__ + "static/media/cover-home-6.7ca369a8.jpg";